module.exports = __webpack_public_path__ + "img/office-yellow.3dbf750f.png";